// DO NOT MODIFY - this file is auto-generated by build-icons.js
// @ts-nocheck
import React from 'react';
import Icon from '../shared/icon';

/* eslint-disable react/jsx-max-props-per-line,react/jsx-space-before-closing,react/jsx-tag-spacing */

const CheckIcon = (props) => (
  <Icon {...props}>
    {
      ({ color, width, height }) => (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16">
          <path fill="inherit" d="M6 10L2.5 6.5l-2 2L6 14l9.5-9.5-2-2L6 10z" />
        </svg>
      )
    }
  </Icon>
);

export default CheckIcon;
